import { useEffect, useState } from "react";
import { Button, NavDropdown } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../app/hooks";
import { getIconFromName } from "../../util/Icons";
import { createWalletAsync, getWalletAsync } from "../payments/paymentsSlice";
import { UserCurrency } from "../payments/types";
import { UserCurrencyModal } from "../payments/components/UserCurrencyModal";

export default function WalletNav() {
  const dispatch = useDispatch();

  var userId = useAppSelector((state) => state.auth.user)?.profile?.sub;
  var wallet = useAppSelector((state) => state.payments.wallet);

  const [selectedUserCurrency, setSelectedUserCurrency] =
    useState<UserCurrency>();
  const [displayModal, setDisplayModal] = useState(false);

  const selectUserCurrency = (userCurrency) => {
    setSelectedUserCurrency(userCurrency);
    setDisplayModal(true);
  };

  useEffect(() => {
    dispatch(getWalletAsync(userId));
  }, []);

  const createWallet = () => {
    dispatch(createWalletAsync());
  };

  if (!wallet || wallet.length === 0) {
    return (
      <div className="p-3">
        <p>You don't currently have a wallet</p>
        <Button onClick={() => createWallet()}>Create Wallet</Button>
      </div>
    );
  }

  return (
    <div>
      {wallet &&
        wallet.map((userCurrency, index) => (
          <NavDropdown.Item
            onClick={() => selectUserCurrency(userCurrency)}
            key={index}
          >
            <>
              {userCurrency.currency.name}{" "}
              {getIconFromName(userCurrency.currency.name)} -{" "}
              {userCurrency.amount ?? 0}
            </>
          </NavDropdown.Item>
        ))}
      <UserCurrencyModal
        userCurrency={selectedUserCurrency}
        show={displayModal}
        onHide={() => setDisplayModal(false)}
      />
    </div>
  );
}
